export class UserCancelledRequestError extends Error {
  constructor() {
    super("UserCancelledRequestError");
    this.name = "UserCancelledRequestError";
  }
}
